module.exports = __webpack_public_path__ + "img/fashion_11.6ad654fe.jpg";